import { useState } from 'react';
import {
  Button,
  Select,
  SelectItem,
  Navbar,
  NavbarContent,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  DropdownSection,
  NavbarItem,
  Avatar
} from '@heroui/react';
import OrgForm from './OrgForm';
import OrgSettingsModal from './OrgSettingsModal';
import OrgInviteModal from './OrgInviteModal';
import OrgMemberList from './OrgMemberList';
import ProfileImageModal from './ProfileImageModal';
import AnalyticsModal from './AnalyticsModal';
import LandingPageModal from './LandingPageModal';

const UserBox = ({
  user,
  showLogin,
  showSignup,
  displaySettings,
  displaySignup,
  displayLogin,
  logout,
  setBanner,
  setUser,
  setError
}) => {
  const [showOrgForm, setShowOrgForm] = useState(false);
  const [orgKey, setOrgKey] = useState(user?.active_organization_id);
  const [showInviteModal, setShowInviteModal] = useState(user?.active_organization_id);
  const [showEditOrgModal, setShowEditOrgModal] = useState(false);
  const [showOrgSettings, setShowOrgSettings] = useState(false);
  const [showOrgMembers, setShowOrgMembers] = useState(false);
  const [showProfileImageModal, setShowProfileImageModal] = useState(false);
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [showLandingPage, setShowLandingPage] = useState(false);

  const deleteOrg = async (orgId) => {
    if (window.confirm(`Delete org '${user?.organizations?.filter(o => o._id === orgId)?.[0]?.name}'?`)) {
      const d = await fetch(`/api/v1/organizations/${orgId}`, {method: 'DELETE'});
      if (d.status === 200) {
        const djson = await d.json();
        setBanner(djson['success']);
        const deactivate = await fetch(`/api/v1/organizations/deactivate`, {method: 'PATCH'});
        const deactJson = await deactivate.json();
        setUser(deactJson['user']);
      } else {
        setError("Unknown error while deleting organization: " + d.status);
      }
    }
  }

  const switchOrg = async (orgId) => {
    let okey = undefined;
    if (orgId.currentKey) {
      // this is from the selector here in UserBox
      okey = orgId.currentKey;
      setOrgKey(okey);
    } else {
      okey = orgId;
      setOrgKey(orgId);
    }
    if (okey === 'none' || !okey || okey === '-' || (Object.keys(okey).length === 2 && !okey['currentKey'])) {
      const d = await fetch(`/api/v1/organizations/deactivate`, {method: 'PATCH'});
      if (d.status === 200) {
        window.location.reload();
      } else {
        setError("Error switching organizations!");
      }
    } else {
      const d = await fetch(`/api/v1/organizations/${okey}/activate`, {method: 'PATCH'});
      if (d.status === 200) {
        window.location.reload();
      } else {
        setError("Error switching organizations!");
      }
    }
  }

  return (
    <Navbar as='div' justify='end' maxWidth='full' style={{zIndex: 40, position: 'fixed', paddingBottom: '12px'}}>
      <NavbarContent as='div' justify="end">
        <NavbarItem>
          { showOrgMembers && user.active_organization_id && <OrgMemberList user={user} orgId={user.active_organization_id} dismissModal={() => setShowOrgMembers(false)} /> }
          { showAnalytics && user.active_organization_id && <AnalyticsModal user={user} orgId={user.active_organization_id} dismissModal={() => setShowAnalytics(false)} /> }
          { showLandingPage && user.active_organization_id && <LandingPageModal user={user} orgId={user.active_organization_id} dismissModal={() => setShowLandingPage(false)} /> }
          { showOrgSettings && user.active_organization_id && <OrgSettingsModal user={user} org={user?.organizations.filter(org => org?._id === user?.active_organization_id)?.[0]} setBanner={setBanner} dismissModal={() => setShowOrgSettings(false)} /> }
          { showInviteModal && <OrgInviteModal org={user?.organizations.filter(org => org?._id === user?.active_organization_id)?.[0]}
                                               dismissModal={() => setShowInviteModal(false)} />
          }
          { showEditOrgModal && <OrgForm org={user?.organizations.filter(org => org?._id === user?.active_organization_id)?.[0]}
                                         setBanner={setBanner} dismissModal={() => setShowEditOrgModal(false)} /> }
          { showProfileImageModal && <ProfileImageModal setUser={setUser} user={user} setBanner={setBanner}
                                                        dismissModal={() => setShowProfileImageModal(false)} /> }
        </NavbarItem>
      { !user ?
          <NavbarItem>
            <Button isDisabled={showLogin || (!user && !showSignup)} className='login-button'
                    onPress={() => displayLogin()}>
                Login
            </Button>
            <Button isDisabled={showSignup} className='signup-button'
                    onPress={displaySignup}>
                Sign Up
            </Button>
          </NavbarItem>
        : <NavbarItem style={{display: 'flex', flexDirection: 'row', width: '346px', justifyContent: 'flex-end', zIndex: 99999}}>
            { user.active_organization_id
              && <Dropdown>
                   <DropdownTrigger>
                     <div className='org-menu'>&#8801;</div>
                   </DropdownTrigger>
                   <DropdownMenu>
                     <DropdownSection title={`${user.organizations?.filter(o => o._id === user.active_organization_id)?.[0]?.name}`}>
                       { user.active_organization_id && user.active_organization?.['member']?.role === 'admin'
                         && <DropdownItem onPress={() => deleteOrg(user.active_organization_id)}>Delete</DropdownItem> }
                       { user.organizations?.filter(o => o._id === user.active_organization_id && o.user_id === user.id).length > 0
                         && <DropdownItem onPress={() => setShowEditOrgModal(true)}>Edit</DropdownItem> }
                       { user.active_organization_id && (user.admin || ['admin', 'coadmin'].includes(user.active_organization?.['member']?.role))
                         && <DropdownItem onPress={() => setShowOrgSettings(true)}>Settings</DropdownItem> }
                       { user.active_organization_id
                         && <DropdownItem onPress={() => setShowInviteModal(true)}>Invite</DropdownItem> }
                       { user.active_organization_id
                         && <DropdownItem onPress={() => setShowOrgMembers(true)}>Members</DropdownItem> }
                       { user.active_organization_id
                         && <DropdownItem onPress={() => setShowAnalytics(true)}>Analytics</DropdownItem> }
                       { user.active_organization_id && (user.active_organization?.['member']?.role === 'admin' || user.active_organization?.['member']?.role === 'coadmin')
                         && <DropdownItem onPress={() => setShowLandingPage(true)}>Landing Page</DropdownItem> }
                     </DropdownSection>
                   </DropdownMenu>
                 </Dropdown>
            }

            { (user.active_organization_id || (user.organizations && user.organizations.length > 0))
              && <Select color='warning' onSelectionChange={switchOrg} style={{position: 'absolute', top: '8px', right: '24px', width: '200px'}}
                         selectedKeys={[orgKey || user?.active_organization_id || '-']}
                         defaultSelectedKeys={[orgKey || user?.active_organization_id || '-']}>
                   <SelectItem textValue='No org' key='-'>
                     None
                   </SelectItem>
                   { user.organizations.map(org => <SelectItem selected textValue={org?.name} key={org?._id}>
                                                     {org?.name} ({(org?._id?.$oid || org?._id || '').slice(-4)} · {org?.user_count || '0'} {`user${org?.user_count === 1 ? '' : 's'}`})
                                                   </SelectItem>)
                   }
                 </Select>
            }

            <Dropdown>
              <DropdownTrigger>
                { <Avatar isBordered as='div'
                          style={{fontSize: '28px', color: '#f0f0f0', marginTop: '6px'}}
                          src={user?.avatar}
                          name={user?.email.split('')[0].toUpperCase()} color={user?.admin ? 'danger' : 'secondary'} />
                }
              </DropdownTrigger>
              <DropdownMenu>
                <DropdownSection title={`${user?.email}${user?.admin ? ' (Admin)' : ''}${user?.super_unlimited ? ' - Unlimited ' : ''}`}>
                  <DropdownItem onPress={() => displaySettings()} key='settings'>Settings</DropdownItem>
                  <DropdownItem onPress={() => setShowOrgForm(true)} key='createOrg'>Create Org</DropdownItem>
                  <DropdownItem onPress={() => setShowProfileImageModal(true)} key='updatePicture'>Update Picture</DropdownItem>
                  <DropdownItem onPress={logout} key='logout'>Logout</DropdownItem>
                </DropdownSection>
              </DropdownMenu>
            </Dropdown>
            { showOrgForm && <OrgForm setUser={setUser} switchOrg={switchOrg} user={user} setBanner={setBanner} dismissModal={() => setShowOrgForm(false)} /> }
          </NavbarItem>
      }
      </NavbarContent>
    </Navbar>
  );
}

export default UserBox;
